import { History, Plus } from 'lucide-react';
import { Tooltip } from '@/shared/ui';
import { cn } from '@/shared/lib/cn';
import styles from './AIAssistantHeader.module.css';

export interface AIAssistantHeaderProps {
  onOpenHistory: () => void;
  onNewChat: () => void;
  showNewChat: boolean;
}

export const AIAssistantHeader: React.FC<AIAssistantHeaderProps> = ({
  onOpenHistory,
  onNewChat,
  showNewChat,
}) => (
  <div className={styles.bar}>
    <div className={styles.tools}>
      <Tooltip content="История чатов" side="bottom">
        <button
          type="button"
          className={cn(styles.btn, styles.toolBtn)}
          aria-label="История чатов"
          onClick={onOpenHistory}
        >
          <History size={18} aria-hidden />
        </button>
      </Tooltip>
      {showNewChat && (
        <Tooltip content="Новый чат" side="bottom">
          <button
            type="button"
            className={cn(styles.btn, styles.toolBtn)}
            aria-label="Новый чат"
            onClick={onNewChat}
          >
            <Plus size={18} aria-hidden />
          </button>
        </Tooltip>
      )}
    </div>
  </div>
);
